export enum AgreementType {
  ADMIN,
  TIME,
  DEAL,
  SYSTEM
}
